<template>
    <div>
        <el-drawer title="修改计划状态" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
            append-to-body @close="close">
            <div class="drawer-content">
                <el-form :model="formData" ref="formData" label-position="top" size="medium">
                    <el-form-item prop="status" required>
                        <span slot="label">定向计划状态：</span>
                        <el-radio-group v-model="formData.status">
                            <el-radio :label="1" border>进行中</el-radio>
                            <el-radio :label="2" border>已完成</el-radio>
                            <el-radio :label="3" border>已取消</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                <el-alert type="warning" title="关于暂停推广（及时生效）" :closable="false">
                    <div>1、无法产生新推广：达人将无法发布新的视频和直播来推广商品，即使挂了团购或地点相关锚点也不分佣。</div>
                    <div>2、旧推广不受影响：已发布的视频和进行中的直播，不受影响。将继续产生佣金。</div>
                </el-alert>
                <el-alert type="warning" title="关于结束推广（及时生效）" :closable="false">
                    <div>1、已发布视频不再产生佣金订单：终止后，达人历史视频产生的新订单，不再分佣；已售出订单，核销后仍需支付给达人佣金。</div>
                    <div>2、进行中的直播推广不受影响：终止后，正在进行中的直播推广产生的订单，仍按照直播开始时的佣金比例结算。</div>
                    <div>3、该计划终止7天以后，才能再次针对该团购创建新的【通用计划】，重新针对商品新建计划后，历史视频按新建的佣金比例分佣。</div>
                </el-alert>
            </div>
            <div class="drawer-footer">
                <el-button @click="close">取消</el-button>
                <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
            </div>
        </el-drawer>
    </div>
</template>
<script>
const defaultData = {
    activityId: "",
    status: "",
}
export default {
    data() {
        return {
            drawerShow: false,
            btnLoading: false,
            formData: {
                ...defaultData
            },
        }
    },
    methods: {
        close() {
            this.$refs.formData.resetFields();
            this.drawerShow = false;
            this.formData = {
                ...defaultData
            }
        },
        show(data) {
            if (data) {
                this.formData = {
                    activityId: data.activityId,
                    status: data.status,
                }
            }
            this.drawerShow = true;
        },
        // 提交
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: "/activity/cps/updateStatus",
                        params: { ...this.formData },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
</style>